import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Upper-case the first character of a free-text value so fields "self
 * correct" to a capital letter as the user types (SX-40). Only index 0 is
 * touched, so the string length is preserved and the caret can be restored
 * without jumping. Returns the value unchanged when it's empty or already
 * starts with an upper-case character.
 */
export function capitalizeFirstLetter(value: string): string {
  if (!value) return value
  const first = value.charAt(0)
  const upper = first.toUpperCase()
  return upper === first ? value : upper + value.slice(1)
}
